
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns635b465785ddb6e6e3c4a0ebaa69edb4en from './en.yaml'
            i18n.addResourceBundle('en', '635b465785ddb6e6e3c4a0ebaa69edb4', flattenObject(ns635b465785ddb6e6e3c4a0ebaa69edb4en), true, true);
        
        export default '635b465785ddb6e6e3c4a0ebaa69edb4';
    